import { PayHeader } from "../Paymentheader/PayHeader";
import "./credit.css";
import { Button, Card, Result, message } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import axiosInstance from "../../Redux/axios/AxiosInstance";
import { useState, useEffect } from "react";
import {
  KYC_Status,
  SaveTransID,
  Policy_PDF,
} from "../../Redux/actions/NumBikeation";
import axiosInCar from "../../Redux/axios/AxiosInCar";
export const IciciCredit = () => {
  const dispatch = useDispatch();
  const PolicyDwnld = useSelector(
    (state) => state?.vehicledetail?.createProposal?.data
  );
  const InsurId = useSelector((state) => state?.vehicledetail?.bikenum);
  const InsurIdCar = useSelector((state) => state?.cardetail?.carnum);
  const TRID = useSelector((state) => state?.vehicledetail?.TID);
  const Route = useSelector((state) => state?.common?.route);
  const SQQData = useSelector((state) => state?.common?.selectedQuote);
  // console.log(SQQData)
  console.log("tr id", Route);
  //let PolicyDwnld = JSON.parse(localStorage.getItem("create_proposal"));
  const [loading, setLoading] = useState(false);
  // const [Transaction, setTransaction] = useState('')

  const history = useHistory();

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    console.log(urlParams.toString());
    const transactionId = urlParams.get("transaction_id");
    dispatch(SaveTransID(transactionId));
    if (transactionId) {
      history.push(`/IciciCredit?transaction_id=${transactionId}`);
    }
  }, [TRID, history]);

  const handleKYC = () => {
    // const RouteAp =
    //   Route === "icici/bike_insurance"
    //     ? "bike_insurances"
    //     : Route === "icici/car_insurance"
    //     ? "car_insurances"
    //     : null;

    setLoading(true);
    let post = {
      insurance_id: InsurId?.bike_insurance_id,
      transaction_id: TRID,
    };
    axiosInstance
      .post(
        `v2/bike_insurances/${InsurId?.bike_insurance_id}/insurers/${SQQData?.provider}/pdf_generation`,
        post
      )
      .then((res) => {
        console.log(res);
        let data = res?.data?.data;
        // const { policy_pdf_link } = res?.data?.data;
        //dispatch(KYC_Status(data))
        console.log(data?.policy_pdf_link);
        if (data?.policy_pdf_link) {
          window.open(data?.policy_pdf_link, "_blank");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err?.response);
        message.error(err?.response?.data?.message);
        setLoading(false);
      });
  };
  const handleKYCCar = () => {
    // const RouteAp =
    //   Route === "icici/bike_insurance"
    //     ? "bike_insurances"
    //     : Route === "icici/car_insurance"
    //     ? "car_insurances"
    //     : null;

    setLoading(true);
    let post = {
      insurance_id: InsurIdCar?.car_insurance_id,
      transaction_id: TRID,
    };
    axiosInCar
      .post(
        `v2/car_insurances/${InsurIdCar?.car_insurance_id}/insurers/${SQQData?.provider}/pdf_generation`,
        post
      )
      .then((res) => {
        console.log(res);
        let data = res?.data?.data;
        //dispatch(KYC_Status(data))
        console.log(data?.policy_pdf_link);
        if (data?.policy_pdf_link) {
          window.open(data?.policy_pdf_link, "_blank");
        }
        // console.log(data);
        // if (data) {
        //   window.open(data, "_blank");
        // }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err.response);
        message.error(err.response.data.message);
        setLoading(false);
      });
  };

  return (
    <>
      <PayHeader />
      {Route === "icici/bike_insurance" ? (
        <>
          <div className="row justify-content-center py-3">
            <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
              <Result
                status="success"
                title="Download Policy Pdf"
                subTitle={`Proposal No: ${PolicyDwnld?.policyNumber}`}
                extra={[
                  <Button
                    loading={loading}
                    onClick={handleKYC}
                    type="primary"
                    key="console"
                  >
                    Download
                  </Button>,
                ]}
              />
            </Card>
          </div>
        </>
      ) : (
        <>
          <div className="row justify-content-center py-3">
            <Card className="cnfrm-card col-xl-6 col-lg-6 col-md-6 col-sm-8">
              <Result
                status="success"
                title="Download Policy Pdf"
                subTitle={`Proposal No: ${PolicyDwnld?.policyNumber}`}
                extra={[
                  <Button
                    loading={loading}
                    onClick={handleKYCCar}
                    type="primary"
                    key="console"
                  >
                    Download
                  </Button>,
                ]}
              />
            </Card>
          </div>
        </>
      )}
      <div className="footter-md-cnfrm">
        <div className="footter-md-1">
          <p>
            Registration No. 742, Registration Code No. IRDA/ DB 797/ 19, Valid
            till 09/06/2024, License category- Direct Broker (Life & General)
          </p>
          <p> solely based on the information received from the insurers.</p>
        </div>
        <div className="footer-md-2">
          <p>@Copyright 2018-2024</p>
          <p>
            <a href="">VIBE</a>
          </p>
          <p>All rights reserved</p>
        </div>
      </div>
    </>
  );
};
